import { COPY } from '../content';
import { apiGet, type Overview as OverviewData } from '../api';
import { useAsync } from '../hooks';
import { money, dateOnly, pluralize } from '../format';
import { Spinner, LoadError, StatTile, Card } from '../components/ui';

export function Overview() {
  const { data, loading, error, reload } = useAsync(() => apiGet<OverviewData>('/v1/admin/overview'), []);

  // The "Needs you" list: only the things with a non-zero count, each a link to its screen.
  const needs = data
    ? [
        { n: data.applicationsInReview, label: COPY.overview.applicationsToReview, href: '#/applications' },
        { n: data.proofToConfirm, label: COPY.overview.proofToConfirm, href: '#/applications' },
        { n: data.moderationOpen, label: COPY.overview.flaggedPosts, href: '#/moderation' },
        { n: data.couponReview, label: COPY.overview.couponToReview, href: '#/money' },
      ].filter((x) => x.n > 0)
    : [];

  return (
    <div>
      <h1 className="screen-title">{COPY.overview.title}</h1>
      <p className="screen-sub">{COPY.overview.sub}</p>

      {loading ? <Spinner /> : null}
      {error ? <LoadError message={error} onRetry={reload} /> : null}

      {data ? (
        <>
          <Card title={COPY.overview.needsYou}>
            {needs.length === 0 ? (
              <p className="muted small">{COPY.overview.allClear}</p>
            ) : (
              <div className="needs">
                {needs.map((x) => (
                  <a key={x.label} href={x.href}>
                    <span>{x.label}</span>
                    <span className="n">{x.n}</span>
                  </a>
                ))}
              </div>
            )}
            <div className="kv" style={{ marginTop: 6 }}>
              <span className="k">{COPY.overview.nextBatch}</span>
              <span className="v">{dateOnly(data.nextBatchDateIso)}</span>
            </div>
          </Card>

          <div className="stats">
            <StatTile href="#/applications" n={data.applicationsInReview} label={pluralize(data.applicationsInReview, 'application')} />
            <StatTile href="#/money" n={data.couponReview} label={pluralize(data.couponReview, 'coupon line')} />
            <StatTile href="#/moderation" n={data.moderationOpen} label="flagged in the feed" />
            <StatTile href="#/members" n={data.members} label={pluralize(data.members, 'member')} />
            <StatTile href="#/money" n={money(data.liabilityCents)} label={COPY.money.liability} />
          </div>
        </>
      ) : null}
    </div>
  );
}
